import axios from "axios"
import { environment } from "environment/environment"
import { AppResponse } from "models/Response"

export interface MerchantPortalLoginData {
  emailOrUserName: string
  password: string
  termsAndConditions?: boolean
}

export interface MerchantPortalLoginResult {
  platform: "shopify" | "custom"
  shop: string
  integrationId: string
  session: string
  storeName: string
  redirectPath: string
  redirectUrl: string
}

export class MerchantPortalService {
  public static async login(
    data: MerchantPortalLoginData
  ): Promise<AppResponse<MerchantPortalLoginResult> & { email?: string; errorCode?: number }> {
    const ep = `${environment.api_url}/api/v1/integrations/merchant-portal/login`
    const res = await axios.post<
      MerchantPortalLoginData,
      AppResponse<MerchantPortalLoginResult> & { email?: string; errorCode?: number }
    >(ep, {
      emailOrUserName: data.emailOrUserName,
      password: data.password,
    })
    return res
  }
}
